import React from 'react';
import { Moon, CheckCircle, TrendingUp, Users, Award, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../../components/ui/badge';

const SleepBand = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1220]">
      <div className="relative bg-gradient-to-r from-[#6366F1]/20 via-[#0B1220] to-[#7C3AED]/20 border-b border-[#1F2A3A] pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-xl bg-[#6366F1]/20 flex items-center justify-center">
              <Moon size={32} className="text-[#6366F1]" />
            </div>
            <div>
              <Badge className="bg-[#6366F1]/20 text-[#6366F1] border-[#6366F1]/30 mb-2">In R&D</Badge>
              <h1 className="text-5xl md:text-6xl font-bold text-white">Yamai SleepBand</h1>
            </div>
          </div>
          <p className="text-[#8A90A0] text-xl max-w-3xl">Smart Sleep Analysis Bracelet with AI-Powered Insights</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-6">Overview</h2>
          <div className="bg-[#1F2A3A]/30 backdrop-blur-sm rounded-2xl p-8 border border-[#1F2A3A]">
            <p className="text-[#E6E8EF] text-lg leading-relaxed mb-4">
              Yamai SleepBand is a smart bracelet dedicated to analyzing sleep quality using biosensors and AI. It enables users and doctors to understand sleep patterns, detect breathing problems, and monitor sleep apnea.
            </p>
            <p className="text-[#8A90A0] leading-relaxed">
              With AI-powered sleep stage detection (light, deep, REM), HRV stress analysis, and morning smart reports, SleepBand helps improve sleep quality and overall health.
            </p>
          </div>
        </section>

        <section className="bg-gradient-to-r from-[#6366F1]/10 to-[#7C3AED]/10 backdrop-blur-sm rounded-2xl p-8 border border-[#6366F1]/30">
          <h2 className="text-2xl font-bold text-white mb-4">Get Involved</h2>
          <p className="text-[#8A90A0] mb-6">Interested in partnering, investing, or collaborating on this project?</p>
          <div className="flex flex-wrap gap-4">
            <Button onClick={() => navigate('/contact')} className="bg-[#6366F1] hover:bg-[#6366F1]/80 text-white">
              Contact Us <ArrowRight size={20} className="ml-2" />
            </Button>
            <Button onClick={() => navigate('/projects')} variant="outline" className="border-[#8A90A0]/30 text-white hover:bg-[#1F2A3A]/50">
              Back to Projects
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SleepBand;
